import {
	getTripsRequest, getTransporterOrdersRequest, sendTripRequest,
	getTripsByIdsRequest
} from '../requests';
import searchFilterActions from './searchFilter/TripSearch.actions.js';
import { cleanLocationTags, baseUrl } from '@/core';

function setValue({ commit }, { value, key }) {
	commit('setValue', { value, key });
}

function cleanSearchFilter(searchFilter) {
	return {
		etd: searchFilter.etd,
		statusReadyOrHigher: true,
		fromLocation: Array.isArray(searchFilter.fromLocation) ? cleanLocationTags(searchFilter.fromLocation) : null,
		toLocation: Array.isArray(searchFilter.toLocation) ? cleanLocationTags(searchFilter.toLocation) : null,
		tripType: Array.isArray(searchFilter.tripType) ? searchFilter.tripType.map (x => x.id) : [],
		cargoCarrier: Array.isArray(searchFilter.cargoCarrier) ? searchFilter.cargoCarrier.map(x => ({ id: x.id, description: x.description, type: x.type, op: x.op })) : [],
		status: searchFilter.status || [],
	};
}

async function fetchTrips({ commit, state: { searchFilter, tripDetails } }) {
	commit('setValue', { value: true, key: 'tripsLoading' });
	try {
		let searchTrips = searchFilter.tripType.length === 0 || searchFilter.tripType.some(x => x.id !== 'external');
		let serachExternalTrips = searchFilter.tripType.length === 0 || searchFilter.tripType.some(x => x.id === 'external');

		let trips = searchTrips ? await getTripsRequest(cleanSearchFilter(searchFilter)) : [];
		let externalTrips = serachExternalTrips ? await getTransporterOrdersRequest({ etdFrom: searchFilter.etd.from, etdTo: searchFilter.etd.to }) : [];
		commit('setTrips', { trips, externalTrips });

		if (tripDetails) commit('setTripDetails', tripDetails.id);
	} catch (err) {
		throw new Error('failedToFetch');
	} finally {
		commit('setValue', { value: false, key: 'tripsLoading' });
	}
}

async function loadSingleTrip({ commit }, id) {
	try {
		if (!id) return;
		let trips = await getTripsByIdsRequest([id]);
		commit('setTrips', { trips, externalTrips: [] });
		commit('setTripDetails', id);
	} catch (error) {
		throw new Error(error);
	}
}

async function getTripsByIds({ state, commit }) {
	try {
		let ids = state.trips.map(x => x.id);
		if (!ids || ids.length <= 0) return;
		let trips = await getTripsByIdsRequest(ids);
		commit('setTrips', { trips, externalTrips: [] });
	} catch (error) {
		throw new Error(error);
	}
}

async function tripLiveUpdate({ state, commit, dispatch }) {
	if (state.liveUpdateInProgress) return;
	commit('set', (state) => { state.liveUpdateInProgress = true; });
	// Force request to be allowed if no return after minute
	setTimeout(() => {
		commit('set', (state) => { state.liveUpdateInProgress = false; });
	}, 60000);
	await dispatch('fetchTrips');
	if (state.tripDetails) {
		// Update tripDetails
		commit('setTripDetails', state.tripDetails.id);
	}
	commit('set', (state) => { state.liveUpdateInProgress = false; });
}

function startPollingTrips({ commit, dispatch }) {
	commit('set', (state) => {
		state.pollInterval = setInterval(() => { dispatch('tripLiveUpdate'); }, 20000);
	});
}

async function stopPollingTrips({ commit }) {
	commit('set', (state) => { clearInterval(state.pollInterval); });
}

function setTripDetails({ commit }, id) {
	commit('setTripDetails', id);
}

function loadSavedSearch({ commit }, savedSearch) {
	if (savedSearch) commit('loadSavedSearch', savedSearch);
}

async function sendTripToConfirm({}, tripId) {
	try {
		await sendTripRequest(tripId);
	} catch (error) {
		throw new Error('failedToSendTrip');
	}
}

async function getLoadingList(_, { tripIds, landscape }) {
	let base = baseUrl();
	let locale = localStorage.getItem('locale') || 'no';
	let landscapeOrientation = landscape ? '/landscape' : '';
	if (Array.isArray(tripIds) && tripIds.length > 1) {
		let form = document.createElement('form');
		form.target = '_blank';
		form.method = 'POST';
		form.action = `${base}/documents/loadingList/${locale}/merged${landscapeOrientation}`;
		form.style.display = 'none';

		let input = document.createElement('input');
		input.name = 'ids';
		input.value = tripIds;
		form.appendChild(input);

		document.body.appendChild(form);
		form.submit();
		document.body.removeChild(form);
	} else {
		let url = `${base}/documents/loadingList/${locale}/${tripIds}${landscapeOrientation}`;
		window.open(url);
	}
}

export default {
	...searchFilterActions,
	setValue,
	fetchTrips,
	loadSingleTrip,
	getTripsByIds,
	setTripDetails,
	tripLiveUpdate,
	loadSavedSearch,
	sendTripToConfirm,
	startPollingTrips,
	stopPollingTrips,
	getLoadingList,
};
